import axios from 'axios';

import {
  ALLOWED_FILE_EXTENSIONS,
  AllowedFileExtension,
  FileUploadData,
  FileUploadRequest,
  FileValidationResult,
} from '../types/s3Types';
import { api } from './api';

export const getPresignedUrl = async (
  file: File,
  fileType: 'PRODUCT' | 'BUSINESS_CERT' = 'PRODUCT',
): Promise<string> => {
  try {
    const requestBody: FileUploadRequest = {
      fileInfoList: [
        {
          fileType,
          fileName: file.name,
        },
      ],
    };

    const response = await api.post<FileUploadData>(
      '/api/v1/s3/upload',
      requestBody,
    );

    if (
      !response.success ||
      !response.data ||
      !response.data.urlList ||
      response.data.urlList.length === 0
    ) {
      throw new Error('파일 업로드 응답이 올바르지 않습니다.');
    }

    return response.data.urlList[0].url;
  } catch (error) {
    console.error('Get presigned URL error:', error);
    if (error instanceof Error) {
      throw new Error(error.message || 'presigned URL 생성에 실패했습니다.');
    }
    throw error;
  }
};

export const uploadFileToS3 = async (
  url: string,
  file: File,
): Promise<string> => {
  try {
    await axios.put(url, file, {
      headers: { 'Content-Type': file.type },
    });
    return url.split('?')[0];
  } catch (error) {
    console.error('Error uploading file to S3:', error);
    throw error;
  }
};

export const validateFileExtension = (fileName: string): boolean => {
  const extension = fileName
    .split('.')
    .pop()
    ?.toLowerCase() as AllowedFileExtension;
  return extension ? ALLOWED_FILE_EXTENSIONS.includes(extension) : false;
};

export const validateFileName = (fileName: string): FileValidationResult => {
  if (fileName.length < 1 || fileName.length > 255) {
    return {
      isValid: false,
      error: '파일명은 1-255자 사이여야 합니다.',
    };
  }

  if (fileName.includes('+')) {
    return {
      isValid: false,
      error: '파일명에 "+" 문자가 포함될 수 없습니다.',
    };
  }

  return { isValid: true };
};

export const validateFile = (file: File): FileValidationResult => {
  const extensionValid = validateFileExtension(file.name);
  if (!extensionValid) {
    return {
      isValid: false,
      error: `허용되지 않는 파일 확장자입니다. 허용 확장자: ${ALLOWED_FILE_EXTENSIONS.join(', ')}`,
    };
  }

  return validateFileName(file.name);
};
